import { driverLogApi } from './driverLogApi'
import { GetListParam } from './driverLogTypes'

async function getList(params: GetListParam) {
  const logs = await driverLogApi.getList(params)
  return logs
}

export const driverLogService = { getList }
